import { sfAuth } from './SFAuth';

/**
 * FusionAuth role that gates all Deploy Dashboard UI.
 */
export const PRODUCTION_ADMIN_ROLE = 'productionAdmin';

/**
 * True when the current session carries the `productionAdmin` role claim.
 * Reuse this helper anywhere Deploy Dashboard access must be gated — do not
 * inline the role string in routes or components.
 */
export const hasProductionAdminAccess = (): boolean => sfAuth.hasRole(PRODUCTION_ADMIN_ROLE);

export const QA_ADMIN_ROLE = 'qaAdmin';

export const hasQaAdminAccess = (): boolean => sfAuth.hasRole(QA_ADMIN_ROLE);

/**
 * Canonical super-admin role claim. Note there is NO hyphen — the string is
 * `superadmin` in both wsapi and FusionAuth. This is the platform's skeleton
 * key: `RequireRole` (see RequireRole.tsx) treats it as an automatic pass
 * regardless of which role it's checking. Also gate sensitive tenant
 * operations (e.g. platform billing edits) on this rather than inlining the
 * string.
 */
export const SUPER_ADMIN_ROLE = 'superadmin';

export const hasSuperAdminAccess = (): boolean => sfAuth.hasRole(SUPER_ADMIN_ROLE);
